lmApp
  .controller('NGBannerController', ['$scope', '$rootScope', '$q', '$templateCache', '$compile', 'CategoryService', 'GenreService', 'AdsResource', 'AdsService', 'ModalWindowService', 'ToastService', 'ManageAssetsWindow', 'GenreResource', 'CategoryResource', 'AssetResource',
    function ($scope, $rootScope, $q, $templateCache, $compile, CategoryService, GenreService, AdsResource, AdsService, ModalWindowService, ToastService, ManageAssetsWindow, GenreResource, CategoryResource, AssetResource) {
      $scope.loading = false;

      var newBannerDefaults = {
          name: '',
          pictures: [{source: ''}],
          _selectedTags: {
              Screens: [],
              Categories: [],
              Genres: []
          },
          _link_info: {
              type: 'asset',
              asset: {},
              link: ''
          },
          _rotation_start: moment.utc(),
          _rotation_end: moment.utc().add(1, 'year'),
          _error: {}
      };

      $scope.tagSelector = {
          Screens: [{
            id: 'home',
            title: 'Home'
          }],
          Categories: [],
          Genres: []
      };

      $scope.ads = [];

      var genreList = [];
      var categoryList = {};

      var capitalizeFirstLetter = function(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      };

      var parseTags = function (tags) {
          var result = {
            CustomTags: {
              Screens: [],
              Categories: [],
              Genres: []
            },
            AutoTags: []
          };
          if (!tags) {
              return result
          }
          for(var i = 0; i < tags.length; i++) {
              var parts = tags[i].split(':');
              if (parts.length !== 2) {
                continue
              }
              var tag = parts[0];
              var elemId = parts[1];
              if (tag[0] === "!") {
                switch (tag) {
                  case '!category_id':
                    result.AutoTags.push({id: Number(elemId), type: "Category"});
                    break;
                  case '!genre_id':
                    result.AutoTags.push({id: Number(elemId), type: "Genre"});
                }
              } else {
                switch (tag) {
                  case 'screen':
                    result.CustomTags.Screens.push({id: elemId, type: "Screen", title: capitalizeFirstLetter(elemId) });
                    break;
                  case 'category_id':
                    result.CustomTags.Categories.push({id: Number(elemId), type: "Category"});
                    break;
                  case 'genre_id':
                    result.CustomTags.Genres.push({id: Number(elemId), type: "Genre"});
                }
              }
        }
        return result;
      };

      var updateTags = function (ad) {
          if (genreList.length) {
              for(var i = 0; i < ad._selectedTags.Genres.length; i++) {
                  ad._selectedTags.Genres[i].title = _.get(_.find(genreList, {id: ad._selectedTags.Genres[i].id}), 'title', '');
              }
              for(i = 0; i < ad._autoTags.length; i++) {
                  if (ad._autoTags[i].type === "Genre") {
                      ad._autoTags[i].title = _.get(_.find(genreList, {id: ad._autoTags[i].id}), 'title', '');
                  }
              }
          }
          if (categoryList.length) {
              for(i = 0; i < ad._selectedTags.Categories.length; i++) {
                  ad._selectedTags.Categories[i].title = _.get(_.find(categoryList, {id: ad._selectedTags.Categories[i].id}), 'title', '');
              }
              for(i = 0; i < ad._autoTags.length; i++) {
                  if (ad._autoTags[i].type === "Category") {
                      ad._autoTags[i].title = _.get(_.find(categoryList, {id: ad._autoTags[i].id}), 'title', '');
                  }
              }
          }
          return ad
      };

      var parseAdLink = function (link) {
        var result = {
          type: '',
          asset: {},
          link: ''
        };
        if (link.startsWith("asset://")) {
          result.type = 'asset';
          result.asset = {id: Number(link.split('://')[1])}
        } else if (link !== '') {
          result.type = 'external';
          result.link = link
        } else {
          result.type = 'nourl';
        }
        return result
      };

      $scope.getAds = function () {
        if ($scope.loading) return;
        $scope.loading = true;
        $rootScope.showLinearProgress('#bannerLoader');

          var params = {
            '$orderby': 'order',
            '$expand': 'pictures(url),tags',
          };

          AdsResource.get(params).$promise
          .then(function (data) {
            var assetIDs = [];
            $scope.ads = data.map(function (ad, i) {
              var parsedTags = parseTags(ad.tags);
              ad._selectedTags = parsedTags.CustomTags;
              ad._autoTags = parsedTags.AutoTags;
              ad._rotation_start = new Date(ad.rotation_start);
              ad._rotation_end = new Date(ad.rotation_end);
              ad._link_info = parseAdLink(ad.url);
              if (!ad.pictures) {
                  ad.pictures = [{source: ''}]
              }
              if (ad._link_info.type === 'asset') {
                  assetIDs.push(ad._link_info.asset.id)
              }
              if (ad.condition_in_rotation === "ok" && ad.condition_pictures_available === "ok") {
                ad._status = "active"
              } else {
                ad._status = "inactive"
              }
              return ad;
            });
            for (var i = 0; i < $scope.ads.length; i += 1) {
              $scope.ads[i].order = i + 1
            }
            return assetIDs
          })
          .then(function (assetIDs) {
              if (assetIDs.length) {
                  AssetResource.get({'id[in]': assetIDs.join(',')}).$promise
                      .then(function (data) {
                          var assetMap = {};
                          data.forEach(function (asset) {
                              assetMap[asset.id] = asset;
                          });
                          angular.forEach($scope.ads, function(ad) {
                              if (ad._link_info.type === 'asset') {
                                  if (assetMap.hasOwnProperty(ad._link_info.asset.id)) {
                                      ad._link_info.asset.title = assetMap[ad._link_info.asset.id].name;
                                      ad._link_info.asset.type = assetMap[ad._link_info.asset.id].type
                                  }
                              }
                          });
                      })
                      .catch(function (reason) {
                          $rootScope.debugInfo(reason, 'silent');
                          ToastService.Small({
                              title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                              color: 'amber',
                              icon: 'server-off',
                              blocked: true
                          }, 1000 * 3);
                      });
              }
             return
          })
          .then(function () {
            GenreResource.get().$promise
              .then(function (data) {
                genreList = data
                  .filter(function (genre) {
                    return !genre.ext_id.startsWith("epg:");
                  })
                  .map(function (genre) {
                    return {
                      id: genre.id,
                      title: genre.name
                    }
                  });
                angular.forEach($scope.ads, function(ad) {
                    ad = updateTags(ad);
                });
                $scope.tagSelector.Genres = genreList
              })
              .catch(function (reason) {
                $rootScope.debugInfo(reason, 'silent');
                ToastService.Small({
                  title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                  color: 'amber',
                  icon: 'server-off',
                  blocked: true
                }, 1000 * 3);
              });
          })
          .then(function () {
            CategoryResource.get().$promise
              .then(function (data) {
                categoryList = data.map(function (category) {
                  return {
                    id: category.id,
                    title: category.name
                  }
                });
                angular.forEach($scope.ads, function(ad) {
                  ad = updateTags(ad);
                });

                $scope.loading = false;
                $rootScope.hideLinearProgress('#bannerLoader');
                $scope.tagSelector.Categories = categoryList
              })
              .catch(function (reason) {
                $scope.loading = false;
                $rootScope.hideLinearProgress('#bannerLoader');
                $rootScope.debugInfo(reason, 'silent');
                ToastService.Small({
                  title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                  color: 'amber',
                  icon: 'server-off',
                  blocked: true
                }, 1000 * 3);
              });
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#bannerLoader');
            $rootScope.debugInfo(reason, 'silent');
            ToastService.Small({
              title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
              color: 'amber',
              icon: 'server-off',
              blocked: true
            }, 1000 * 3);
          })
      };

      var convertAd = function (ad) {
          var adRepresentation = {
              name: ad.name,
              rotation_start: ad._rotation_start.format(),
              rotation_end: ad._rotation_end.format(),
              ext_id: 'local:' + translit(ad.name) + moment.utc(),
              pictures: [
                  {
                      type: "picture",
                      category: ad.pictures[0].category || '2x1',
                      group_id: "picture",
                      source: ad.pictures[0].source,
                      deployer: ad.pictures[0].deployer || 'origin'
                  }
              ],
              tags: []
          };
          if (ad._link_info.type === 'external') {
              adRepresentation.url = ad._link_info.link
          }
          if (ad._link_info.type === 'asset') {
              adRepresentation.url = "asset://" + ad._link_info.asset.id
          }
          if (ad._link_info.type === 'nourl') {
              adRepresentation.url = ''
          }
          if (ad._selectedTags.Screens && ad._selectedTags.Screens.length) {
              ad._selectedTags.Screens.forEach(function (value) {
                  adRepresentation.tags.push('screen:' + value.id);
              });
          }
          if (ad._selectedTags.Genres && ad._selectedTags.Genres.length) {
              ad._selectedTags.Genres.forEach(function (value) {
                  adRepresentation.tags.push('genre_id:' + value.id);
              });
          }
          if (ad._selectedTags.Categories && ad._selectedTags.Categories.length) {
              ad._selectedTags.Categories.forEach(function (value) {
                  adRepresentation.tags.push('category_id:' + value.id);
              });
          }
          return adRepresentation
      };

      $scope.createBanner = function () {
        if ($scope.loading) return;

        $scope.newBanner = new AdsResource(angular.copy(newBannerDefaults));

        var inner = $templateCache.get('new-banner.tpl.html');
        inner = $compile(inner)($scope);

        $scope.window = ModalWindowService.Open({
          content: inner,
          isFixed: true,
          clear: true,
          keyboard: true,
          actions: [
            {
              title: 'Create',
              color: 'green',
              check: function () {
                var validate = AdsService.ValidateAd($scope.newBanner);
                if (!validate) {
                  ToastService.Big({
                    color: 'amber',
                    title: 'Empty fields',
                    text: 'Not all required fields are filled',
                    icon: 'alert'
                  }, 30 * 1000);
                }
                return validate;
              },
              fn: function () {
                  $scope.loading = true;
                  $rootScope.showLinearProgress('#bannerLoader');

                  AdsResource.add(convertAd($scope.newBanner)).$promise
                  .then(function (response) {
                    var newAd = angular.copy($scope.newBanner);
                    var parsedTags = parseTags(response.data.tags);
                    newAd.id = response.data.id;
                    newAd._autoTags = parsedTags.AutoTags;
                    newAd._selectedTags = parsedTags.CustomTags;
                    newAd = updateTags(newAd);
                    newAd._rotation_start = new Date(response.data.rotation_start);
                    newAd._rotation_end = new Date(response.data.rotation_end);
                    newAd.condition_in_rotation = response.data.condition_in_rotation;
                    newAd.condition_pictures_available = response.data.condition_pictures_available;
                    if (response.data.condition_in_rotation === "ok" && response.data.condition_pictures_available === "ok") {
                      newAd._status = "active"
                    } else {
                      newAd._status = "inactive"
                    }
                    newAd.pictures[0].state = response.data.pictures[0].state;

                    $scope.ads.push(newAd);

                    ToastService.Small({
                      title: 'The banner has been added',
                      color: 'green',
                      icon: 'plus'
                    }, 20 * 1000);

                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#bannerLoader');
                    return response
                  })
                  .catch(function (reason) {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#bannerLoader');
                    ToastService.Small({
                      title: 'Failed to add banner: ' + _.get(reason, 'data.error.message', 'server error'),
                      color: 'red',
                      icon: 'delete'
                    }, 30 * 1000);
                  });

              }
            },
            {
              title: 'Cancel',
              color: 'red',
              fn: function () {
              }
            }
          ],
          size: {
            s: 11,
            l: 8
          }
        });
      };

      $scope.editBanner = function (ad) {
        if ($scope.loading) return;


        $scope.newBanner = new AdsResource(angular.copy(ad));
        $scope.newBanner._rotation_start = moment(ad._rotation_start).utc();
        $scope.newBanner._rotation_end = moment(ad._rotation_end).utc();

        var inner = $templateCache.get('new-banner.tpl.html');
        inner = $compile(inner)($scope);

        $scope.window = ModalWindowService.Open({
          content: inner,
          isFixed: true,
          clear: true,
          keyboard: true,
          actions: [
            {
              title: 'Update',
              color: 'green',
              check: function () {
                var validate = AdsService.ValidateAd($scope.newBanner);
                if (!validate) {
                  ToastService.Big({
                    color: 'amber',
                    title: 'Empty fields',
                    text: 'Not all required fields are filled',
                    icon: 'alert'
                  }, 30 * 1000);
                }

                return validate;
              },
              fn: function () {
                  $scope.loading = true;
                  $rootScope.showLinearProgress('#bannerLoader');

                  var patchedAd = convertAd($scope.newBanner);
                  delete patchedAd.ext_id;
                  if ($scope.newBanner.pictures[0].source === ad.pictures[0].source) {
                      delete patchedAd.pictures;
                  }

                  AdsResource.update({id: ad.id}, patchedAd).$promise
                      .then(function (response) {
                          var updatedAd = angular.copy($scope.newBanner);

                          var index = $scope.ads.indexOf(ad);
                          $scope.ads[index].name = updatedAd.name;
                          $scope.ads[index]._link_info = updatedAd._link_info;

                          var parsedTags = parseTags(response.data.tags);
                          $scope.ads[index]._autoTags = parsedTags.AutoTags;
                          $scope.ads[index]._selectedTags = parsedTags.CustomTags;
                          $scope.ads[index] = updateTags($scope.ads[index]);
                          $scope.ads[index]._rotation_start = new Date(response.data.rotation_start);
                          $scope.ads[index]._rotation_end = new Date(response.data.rotation_end);
                          $scope.ads[index].condition_in_rotation = response.data.condition_in_rotation;
                          $scope.ads[index].condition_pictures_available = response.data.condition_pictures_available;

                          if (response.data.condition_in_rotation === "ok" && response.data.condition_pictures_available === "ok") {
                              $scope.ads[index]._status = "active"
                          } else {
                              $scope.ads[index]._status = "inactive"
                          }
                          if (response.data.pictures.length && response.data.pictures[0].source !== $scope.ads[index].pictures[0].source) {
                              $scope.ads[index].pictures[0].state = response.data.pictures[0].state;
                              $scope.ads[index].pictures[0].url = response.data.pictures[0].url;
                          }

                          $scope.loading = false;
                          $rootScope.hideLinearProgress('#bannerLoader');
                          ToastService.Small({
                              title: 'The banner has been updated',
                              color: 'green',
                              icon: 'refresh'
                          }, 20 * 1000);
                      })
                      .catch(function (reason) {
                          $scope.loading = false;
                          $rootScope.hideLinearProgress('#bannerLoader');
                          ToastService.Small({
                              title: 'Failed to update banner: ' + _.get(reason, 'data.error.message', 'server error'),
                              color: 'red',
                              icon: 'delete'
                          }, 30 * 1000);
                      });
              }
            },
            {
              title: 'Cancel',
              color: 'red',
              fn: function () {
                $scope.loading = false;
                $rootScope.hideLinearProgress('#bannerLoader');
              }
            }
          ],
          size: {
            s: 11,
            l: 8
          }
        });
      };

      $scope.deleteAd = function (ad) {
          if ($scope.loading) return;
          $scope.loading = true;
          $rootScope.showLinearProgress('#bannerLoader');

          $scope.modalWindowScope = $scope.$new();
          var inner = '<span class="heavy">Are you sure you want <b>to delete</b> the banner "' + ad.name +'"?</span>';

          ModalWindowService.Open({
              content: inner,
              actions: [
                  {
                      title: 'I understand. Do it',
                      color: 'green',
                      fn: function () {
                          AdsResource.remove({id: ad.id}).$promise
                              .then(function () {
                                  var index = $scope.ads.indexOf(ad);
                                  $scope.ads.splice(index, 1);
                                  ToastService.Small({
                                      title: 'The banner was deleted',
                                      color: 'green',
                                      icon: 'delete'
                                  });
                              })
                              .catch(function (reason) {
                                  $scope.loading = false;
                                  $rootScope.hideLinearProgress('#bannerLoader');
                                  $rootScope.debugInfo(reason);
                                  ToastService.Small({
                                      title: 'Failed to remove banner: ' + + _.get(reason, 'data.error.message', 'server error'),
                                      color: 'red',
                                      icon: 'alert'
                                  });
                              });
                      }
                  },
                  {
                      title: 'cancel',
                      color: 'red',
                      fn: function () {
                          $scope.loading = false;
                          $rootScope.hideLinearProgress('#bannerLoader');
                      }
                  }
              ],
              onComplete: function () {
                  $scope.loading = false;
                  $rootScope.hideLinearProgress('#bannerLoader');
                  $scope.modalWindowScope.$destroy();
              }
          });
      };

      $scope.openAssetSearch = function (banner) {
        ManageAssetsWindow.OpenManageAssetsWindow({
          manageAssetsFn: function (asset, toThis) {
            if (asset.id) {
              banner._link_info.asset = {
                id: asset.id,
                title: asset.title,
                type: asset.type
              };
            }
            return true;
          },
          type: 'single',
          title: 'selecting movie or channel for banner',
          view: 'vod,live',
          currentCollection: [banner._link_info.type === 'asset' ? banner._link_info.asset.id : null],
          filter: {}
        });
      };

      $scope.changeBannerOrder = function (banner, index, direction) {
          for (var i = 0; i < $scope.ads.length; i += 1) {
              if (!$scope.ads[i].order) {
                  $scope.ads[i].order = i + 1
              }
          }

          if (direction === 'up') {
              var curr = _.find($scope.ads, {order: index + 1});
              var prev = _.find($scope.ads, {order: index});

              curr.order -= 1
              prev.order += 1
          }

          if (direction === 'down') {
              var curr = _.find($scope.ads, {order: index + 1});
              var next = _.find($scope.ads, {order: index + 2});

              curr.order += 1
              next.order -= 1
          }

          var reqList = [];
          for (var i = 0; i < $scope.ads.length; i += 1) {
              reqList.push(AdsResource.update($scope.ads[i]).$promise)
          }

          $scope.loading = true;

          $q.all(reqList)
              .then(function(values) {
                  $scope.getAds();
                  ToastService.Small({
                      title: 'The banner order has been updated',
                      color: 'green',
                      icon: 'check'
                  });
                  $scope.loading = false;
                  $rootScope.hideLinearProgress('#bannerLoader');
              })
              .catch(function(reason) {
                  $scope.loading = false;
                  $rootScope.hideLinearProgress('#bannerLoader');
                  $rootScope.debugInfo(reason);
                  ToastService.Small({
                      title: 'Failed to update banners',
                      color: 'red',
                      icon: 'server-minus'
                  });
              });

      }

      $scope.getAds();
    }
  ]);
